/* Reformly Home — board video play/pause.

   The export autoplays a muted loop and offers a 44px toggle bottom-right.
   Only loaded when a video URL is set.

   Autoplay is started from an IntersectionObserver rather than the `autoplay`
   attribute: a muted autoplaying video decodes frames for the whole visit
   even while far off screen, which on a long page is the single most
   expensive thing here. Pausing when it leaves the viewport is also what
   keeps the toggle honest — a paused-off-screen video reporting "playing"
   would show the wrong icon on return.
*/
(function () {
  var vids = document.querySelectorAll('[data-rhm-board-video]');
  if (!vids.length) return;

  Array.prototype.forEach.call(vids, function (v) {
    var root = v.closest('.rhm-board__media');
    var btn = root && root.querySelector('[data-rhm-board-toggle]');
    var iPause = btn && btn.querySelector('[data-rhm-icon-pause]');
    var iPlay = btn && btn.querySelector('[data-rhm-icon-play]');

    /* Set by the user pressing pause. Distinct from "paused because it
       scrolled away" — without the distinction, scrolling back would restart
       a video the visitor deliberately stopped. */
    var userPaused = false;

    function paint() {
      var playing = !v.paused && !v.ended;
      if (iPause) iPause.hidden = !playing;
      if (iPlay) iPlay.hidden = playing;
      if (btn) btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    }

    function tryPlay() {
      if (userPaused) return;
      var p = v.play();
      /* Safari/iOS reject play() in some states; the rejection is expected
         and must not surface as an unhandled rejection. */
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    if (btn) {
      btn.addEventListener('click', function () {
        if (v.paused) {
          userPaused = false;
          tryPlay();
        } else {
          userPaused = true;
          v.pause();
        }
        paint();
      });
    }

    v.addEventListener('play', paint);
    v.addEventListener('pause', paint);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { tryPlay(); } else { v.pause(); }
        });
      }, { threshold: 0.25 }).observe(v);
    } else {
      tryPlay();
    }

    /* Reduced motion: load the first frame and hold it. The control still
       works, so the video is available on request rather than withheld. */
    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (rm && rm.matches) {
      userPaused = true;
      v.pause();
    }

    paint();
  });
})();
